'use client';

import ReactQueryClientProvider from './react-query-client-provider';

export default ReactQueryClientProvider;
